import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProviderFormModalComponent } from './provider-form-modal/provider-form-modal.component';
import { ProviderBillByDateComponent } from './provider-bill-by-date/provider-bill-by-date.component';
import { ProviderUpdateModalComponent } from './provider-update-modal/provider-update-modal.component';
import { ProvidersComponent } from './providers-list/providers.component';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'create',
                component: ProviderFormModalComponent,
            },
            {
                path: 'provider-update',
                component: ProviderUpdateModalComponent,
            },
            // {
            //     path: 'providers-range-date',
            //     component: ProviderBillByDateComponent,
            //     canActivate: [AuthGuard],
            // },
            // {
            //     path: 'providers',
            //     component: ProvidersComponent,
            //     canActivate: [AuthGuard],
            // },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ProvidersRoutingModule { }
